export const CONFIG_ERRORS = {
  API_ERROR_CHECK_EMAIL_ADDRESS:
    "A intervenit o eroare la verificarea adresei de e-mail.",
  API_ERROR_LOGIN_CREDENTIALS:
    "A intervenit o eroare cu serverul de autentificare.",
  API_ERROR_SIGNUP: "A intervenit o eroare cu serverul de inregistrare.",
  API_ERROR_EVENT_LIVE: "A intervenit o eroare cu serverul de evenimente.",
};
